import { Link, NavLink, useLocation, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import "./style.css";
import Logo from "../assets/img/GlobalStudyLogo.svg";
export default function Navbar() {
  const location = useLocation();
  const [colorClassName, setClass] = useState("bg-white");
  const [menuOpen, setMenuOpen] = useState(false);
 const navigate = useNavigate();

const isServicePath =
  location.pathname.startsWith("/services") ||
  location.pathname.startsWith("/personalised-guidence/2") ||
  location.pathname.startsWith("/end-to-end-app-service/2") ||
  location.pathname.startsWith("/creative-portfolio-guidance/2") ||
  location.pathname.startsWith("/medical-school-support/2") ||
  location.pathname.startsWith("/phd-application-mentorship/2") ||
  location.pathname.startsWith("/university-preparation/2") ||
  location.pathname.startsWith("/visa-assistance/2");

const isLanguagePath =
  location.pathname.startsWith("/language-prep") ||
  location.pathname.startsWith("/password-english-language-test") ||
  location.pathname.startsWith("/language-cert") ||
  location.pathname.startsWith("/toefl") ||
  location.pathname.startsWith("/doulingo") ||
  location.pathname.startsWith("/pte") ||
  location.pathname.startsWith("/ielts");

const isCourseFinderPath =
  location.pathname === "/" ||
  location.pathname.startsWith("/personalised-guidence/1") ||
  location.pathname.startsWith("/end-to-end-app-service/1") ||
  location.pathname.startsWith("/creative-portfolio-guidance/1") ||
  location.pathname.startsWith("/medical-school-support/1") ||
  location.pathname.startsWith("/phd-application-mentorship/1") ||
  location.pathname.startsWith("/university-preparation/1") ||
  location.pathname.startsWith("/visa-assistance/1");
const isAboutPath = location.pathname.startsWith("/about-us");

//const isHomePath = location.pathname === "/";

  useEffect(() => {
    switch (location.pathname) {
      
      case "/":
     setClass("language-background-header");
        break;
      case "/services":
        setClass("bg-white");
        break;
      case "/language-prep":
        setClass("language-background-header");
        break;
      case "/about-us":
        setClass("bg-white");
        break;
      default:
        setClass("language-background-header");
    }
  }, [location]);

  return (
    <>
      {/* NAVBAR */}
      <nav
        className={`headers-containar flex justify-between items-center px-6 py-4 sticky top-0 z-50 ${colorClassName}`}
      >
        {/* Logo */}
        <Link to="/" className="text-2xl font-bold text-blue-800">
          <div className="group-2">
            <img alt="Group" src={Logo} className="w-48 sm:w-56 md:w-64 lg:w-80 h-auto" />
          </div>
        </Link>

        <ul className="hidden md:flex lg:space-x-8 text-gray-700 font-medium navbar-ipad-view">
          {/* <NavLink
            to="/"
            className={`header-text pb-1 border-b-2 transition-all
      ${
        isHomePath
          ? "border-bottom border-[#051D62] text-[#051D62]"
          : "border-transparent"
      }`}
          >
            Home
          </NavLink> */}
          <NavLink
            to="/"
            className={`header-text pb-1 border-b-2 transition-all
      ${
        isCourseFinderPath
          ? "border-bottom border-[#051D62] text-[#051D62]"
          : "border-transparent"
      }`}
          >
            Course finder
          </NavLink>

          <NavLink
            to="/services"
            className={`header-text pb-1 border-b-2 transition-all
      ${
        isServicePath
          ? "border-bottom border-[#051D62] text-[#051D62]"
          : "border-transparent"
      }`}
          >
            Services
          </NavLink>

          <NavLink
            to="/language-prep"
            className={`header-text pb-1 border-b-2 transition-all
      ${
        isLanguagePath
          ? "border-bottom border-[#051D62] text-[#051D62]"
          : "border-transparent"
      }`}
          >
            Language Prep
          </NavLink>

          <NavLink
            to="/about-us"
            className={`header-text pb-1 border-b-2 transition-all
      ${
        isAboutPath
          ? "border-bottom border-[#051D62] text-[#051D62]"
          : "border-transparent"
      }`}
          >
            About Us
          </NavLink>
        </ul>

        {/* Desktop Button */}
        <div className="master-primary hidden md:flex navbar-ipad-button">
          <Link
            to={
              // location.pathname === "/"
              //   ? "/#features-form-load"
                 location.pathname === "/"
                ? "/#features-form-load"
                : location.pathname === "/service"
                ? "/about-us#features-form-load-about-us"
                : "/about-us#features-form-load-about-us"
            }
            className="button-text"
          >
            Book for counselling
          </Link>
          <img
            className="line-rounded-arrow"
            alt="arrow"
            src="https://c.animaapp.com/HwA6Ml4A/img/line-rounded-arrow-right.svg"
          />
        </div>

        {/* Hamburger */}
        <div
          onClick={() => setMenuOpen(true)}
          className="hamburger-menu  gap-1 cursor-pointer"
        >
          <span className="w-7 h-[3px] bg-[#051d62]"></span>
          <span className="w-7 h-[3px] bg-[#051d62]"></span>
          <span className="w-7 h-[3px] bg-[#051d62]"></span>
        </div>
      </nav>

      {/* MOBILE SLIDE-IN MENU */}
      {menuOpen && (
        <div className="fixed inset-0 z-[999] bg-black/40 backdrop-blur-sm flex justify-end">
          {/* Drawer */}
          <div className="w-72 bg-gradient-to-b from-white/95 to-indigo-100 rounded-l-3xl shadow-xl p-6 animate-slideLeft relative">
            {/* Close Button */}
            <button
              className="absolute top-4 right-4 text-xl text-gray-600"
              onClick={() => setMenuOpen(false)}
            >
              ✕
            </button>

            <div className="mt-10 flex flex-col gap-6 text-[18px] font-medium mobile-navbar-container">
              {/* <NavLink
                to="/"
                className={`header-text pb-1 border-b-2 transition-all
      ${
        isHomePath
          ? "border-bottom border-[#051D62] text-[#051D62]"
          : "border-transparent"
      }`}
              >
                Home
              </NavLink> */}
              <NavLink
                to="/"
                onClick={() => setMenuOpen(false)}
                className={`pb-1 border-b-2 transition-all
    ${
      isCourseFinderPath
        ? "border-bottom border-[#051D62] text-[#051D62]"
        : "border-transparent"
    }`}
              >
                Course Finder
              </NavLink>

              <NavLink
                to="/services"
                onClick={() => setMenuOpen(false)}
                className={`pb-1 border-b-2 transition-all
    ${
      isServicePath
        ? "border-bottom border-[#051D62] text-[#051D62]"
        : "border-transparent"
    }`}
              >
                Services
              </NavLink>

              <NavLink
                to="/language-prep"
                onClick={() => setMenuOpen(false)}
                className={`pb-1 border-b-2 transition-all
    ${
      isLanguagePath
        ? "border-bottom border-[#051D62] text-[#051D62]"
        : "border-transparent"
    }`}
              >
                Language Prep
              </NavLink>
              <NavLink
                to="/about-us"
                onClick={() => setMenuOpen(false)}
                className={`pb-1 border-b-2 transition-all
    ${
      isAboutPath
        ? "border-bottom border-[#051D62] text-[#051D62]"
        : "border-transparent"
    }`}
              >
                About Us
              </NavLink>
            </div>

            {/* CTA CARD */}
            <div className="hamberger-button-section mt-10 p-4 bg-white rounded-2xl shadow-md">
              <h3 className="font-semibold text-[#051d62]">
                Connect to our experts now!
              </h3>
              <Link
                to={
                  // location.pathname === "/"
                  //   ? "/#features-form-load"
                    location.pathname === "/"
                    ? "/#features-form-load"
                    : location.pathname === "/service"
                    ? "/about-us#features-form-load-about-us"
                    : "/about-us#features-form-load-about-us"
                }
                onClick={() => {
                  setMenuOpen(false);
                }}
                className="block mt-4 bg-[#051d62] text-white text-center py-2 rounded-lg font-semibold"
              >
                Book for counselling 
              </Link>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
